class CartShippingEstimate extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    this.storageKey = 'plus2do-cart-shipping-region-v2';
    this.cartSubtotal = Number.parseInt(this.dataset.cartSubtotal || '0', 10) || 0;
    this.currency = this.dataset.currency || 'JPY';
    this.attributeInput = this.querySelector('[data-shipping-estimate-attribute]');
    this.shippingOutput = this.querySelector('[data-shipping-estimate-shipping]');
    this.totalOutput = this.querySelector('[data-shipping-estimate-total]');
    this.regionOutput = this.querySelector('[data-shipping-estimate-region]');
    this.regionInputs = Array.from(this.querySelectorAll('[data-shipping-estimate-region-input]'));

    if (!this.regionInputs.length) return;

    const savedRegion = this.getSavedRegion();
    const savedInput = savedRegion ? this.regionInputs.find((input) => this.hasRegionValue(input, savedRegion)) : null;
    const defaultInput = this.regionInputs.find((input) => this.isDefaultRegion(input)) || this.regionInputs[0];
    const initialInput = savedInput || defaultInput;

    if (initialInput) {
      this.selectRegion(initialInput, savedRegion);
      this.applyRegion(initialInput, false);
    }

    this.regionInputs.forEach((input) => {
      input.addEventListener('change', () => {
        if (this.isSelect(input) || input.checked) this.applyRegion(input, true);
      });
    });
  }

  getSavedRegion() {
    try {
      return window.localStorage.getItem(this.storageKey);
    } catch (error) {
      return null;
    }
  }

  saveRegion(region) {
    try {
      window.localStorage.setItem(this.storageKey, region);
    } catch (error) {
      return;
    }
  }

  isSelect(input) {
    return input.tagName === 'SELECT';
  }

  hasRegionValue(input, region) {
    if (this.isSelect(input)) {
      return Array.from(input.options).some((option) => option.value === region);
    }

    return input.value === region;
  }

  isDefaultRegion(input) {
    if (this.isSelect(input)) {
      return Array.from(input.options).some((option) => option.selected);
    }

    return input.checked;
  }

  selectRegion(input, region) {
    if (this.isSelect(input)) {
      if (region && this.hasRegionValue(input, region)) input.value = region;
      return;
    }

    input.checked = true;
  }

  getRegionData(input) {
    if (this.isSelect(input)) {
      const option = input.options[input.selectedIndex] || input.options[0];

      return {
        value: option ? option.value : input.value,
        shippingRate: Number.parseInt(option ? option.dataset.shippingRate || '0' : '0', 10) || 0,
        regionLabel: option ? option.dataset.regionLabel || option.textContent.trim() : input.value,
      };
    }

    return {
      value: input.value,
      shippingRate: Number.parseInt(input.dataset.shippingRate || '0', 10) || 0,
      regionLabel: input.dataset.regionLabel || input.value,
    };
  }

  applyRegion(input, persist) {
    const region = this.getRegionData(input);
    const shippingText = this.formatMoney(region.shippingRate);
    const totalText = this.formatMoney(this.cartSubtotal + region.shippingRate);

    if (this.shippingOutput) this.shippingOutput.textContent = shippingText;
    if (this.totalOutput) this.totalOutput.textContent = totalText;
    if (this.regionOutput) this.regionOutput.textContent = region.regionLabel;
    if (this.attributeInput) this.attributeInput.value = `${region.regionLabel} / ${shippingText}`;
    if (persist) this.saveRegion(region.value);
  }

  formatMoney(cents) {
    const amount = Math.round(cents / 100);

    if (this.currency === 'JPY') {
      return `¥${amount.toLocaleString('ja-JP')}`;
    }

    try {
      return new Intl.NumberFormat('ja-JP', {
        style: 'currency',
        currency: this.currency,
        currencyDisplay: 'code',
      }).format(amount);
    } catch (error) {
      return `${amount.toLocaleString('ja-JP')} ${this.currency}`;
    }
  }
}

if (!customElements.get('cart-shipping-estimate')) {
  customElements.define('cart-shipping-estimate', CartShippingEstimate);
}